import React from "react";
import { mediaUrl } from "@/lib/api";

// Renders the ministry logo image when available; otherwise a clean flame emblem fallback.
export const Logo = ({ className = "", variant = "light", src }) => {
  const wordColor = variant === "light" ? "#FFFFFF" : "#040F22";
  const subColor = variant === "light" ? "#94A3B8" : "#475569";

  if (src) {
    return (
      <div className={`flex items-center ${className}`} data-testid="brand-logo">
        <img src={mediaUrl(src)} alt="Flames of Fire World Evangelism" className="h-12 w-auto object-contain" />
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <span className="relative inline-flex h-10 w-10 items-center justify-center rounded-sm bg-[#040F22] ring-1 ring-white/10">
        <svg viewBox="0 0 24 24" className="h-6 w-6" aria-hidden="true">
          <path
            d="M12 2c1.5 3.2-.8 4.6-1.8 6.2-1 1.6-.4 3.2.8 3.9.7.4 1-.2.9-1 .8.7 1.4 1.8 1.4 3.1a3.3 3.3 0 1 1-6.6 0c0-2.4 1.4-3.9 1.4-3.9-.2 1.6.4 2.4 1 2.6-1.8-3 1.7-5.1 1.5-8.4C13.9 6 13 3.8 12 2Z"
            fill="#FF5A00"
          />
          <path
            d="M15.6 10.5c1 1.1 1.6 2.6 1.6 4.2a5.2 5.2 0 0 1-2.3 4.3c1-1 1.3-2.2 1.1-3.4.6.2 1 .8 1.1 1.3.5-1.9-.3-4.6-1.5-6.4Z"
            fill="#FF7A33"
          />
        </svg>
      </span>
      <span className="leading-none">
        <span className="block font-display text-sm font-extrabold uppercase tracking-[0.14em]" style={{ color: wordColor }}>
          Flames of Fire
        </span>
        <span className="block text-[10px] font-medium uppercase tracking-[0.28em]" style={{ color: subColor }}>
          World Evangelism
        </span>
      </span>
    </div>
  );
};

export default Logo;
